<template>
  <v-layout row v-show="hasKey()" align-center>
    <v-icon class="deep-orange--text mr-2">warning</v-icon>
    <span v-if="hasPass()" class="deep-orange--text">{{ $t('keyFoot.keyAndPassWarning') }}</span>
    <span v-else>{{ $t('keyFoot.keyWarning') }}</span>
    <v-btn flat @click="clear" class="my-0">{{ $t('keyFoot.forget') }}</v-btn>
  </v-layout>
</template>

<script>
import Local from '@/store/local'

export default {
  data () {
    return {
      store: this.$store
    }
  },
  methods: {
    clear () {
      this.store.player.keyStored = false
      this.store.player.passStored = false

      Local.set('private', {})
    },
    hasKey () {
      return this.store.player.keyStored
    },
    hasPass () {
      return this.store.player.passStored
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// KeyFoot.vue?0ba7185e